<script setup lang="ts">
import { SphField, SphFieldGroup } from '@/components/base/field/'
import type { Reset } from '../types'
import { SphButton } from '@/components/base/button'
import SphInput from '@/components/base/input'
import { useI18n } from '@/composables/i18n'

const { i18n } = useI18n()

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<{
    reset: Reset
}>()
</script>

<template>
    <form
        :action="props.reset.actionUrl"
        method="post"
        novalidate
    >
        <header>
            <h2>{{ i18n.t('Passwort ändern') }}</h2>
            <p>
                {{ i18n.t('Das Passwort muss mindestens 8 Zeichen haben und mindestens eine Zahl und ein Sonderzeichen enthalten.') }}
            </p>
        </header>

        <ul
            v-if="props.reset.errors.length"
            class="errors"
        >
            <li
                v-for="message in props.reset.errors"
                :key="message"
            >
                {{ message }}
            </li>
        </ul>

        <SphFieldGroup>
            <SphField
                v-slot="field"
                :label="i18n.t('Neues Passwort')"
                :placeholder="i18n.t('Ihr neues Passwort')"
                required
            >
                <SphInput
                    :name="props.reset.firstFieldName"
                    type="password"
                    v-bind="field"
                />
            </SphField>

            <SphField
                v-slot="field"
                :label="i18n.t('Passwort wiederholen')"
                :placeholder="i18n.t('Ihr neues Passwort')"
                required
            >
                <SphInput
                    :name="props.reset.secondFieldName"
                    type="password"
                    v-bind="field"
                />
            </SphField>
        </SphFieldGroup>

        <input
            v-if="props.reset.csrfFieldName"
            :name="props.reset.csrfFieldName"
            :value="props.reset.csrfToken"
            type="hidden"
        />

        <footer>
            <SphButton
                type="submit"
                variant="primary"
            >
                {{ i18n.t('Passwort ändern') }}
            </SphButton>
        </footer>
    </form>
</template>

<style scoped>
@reference "@/assets/styles/config.css";

form {
    @apply flex flex-col;
}

header {
    @apply mb-4;

    h2 {
        @apply text-xl font-black mb-2;
    }

    p {
        @apply text-gray-500 leading-normal font-medium;
    }
}

.errors {
    @apply flex flex-col mb-4 text-red-700 font-semibold;
}

footer {
    @apply mt-6;

    .sph-button {
        @apply w-full font-bold!;
    }
}
</style>
